import React from 'react';
import { ScrollText } from 'lucide-react';

const TYPE_LABELS = {
  flight: 'Flight Booking',
  hotel: 'Hotel Accommodation',
  activity: 'Activity / Sightseeing',
  transfer: 'Transfer Service',
  itinerary: 'Travel Itinerary',
};

const VoucherTerms = ({ terms, type }) => {
  if (!terms) return null;

  return (
    <div className="border-t border-[#E5E7EB] bg-white px-10 py-6" data-testid="voucher-terms-section">
      <div className="flex items-center gap-2 mb-3">
        <ScrollText className="h-3.5 w-3.5 text-[#2C3E35]" />
        <p className="uppercase text-[9px] tracking-[0.2em] text-[#6B7280] font-semibold" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Terms & Cancellation Policy — {TYPE_LABELS[type] || 'General'}
        </p>
      </div>
      <div className="text-[11px] text-[#4B5563] leading-relaxed whitespace-pre-line" style={{ fontFamily: "'Outfit', sans-serif" }}>
        {terms}
      </div>
    </div>
  );
};

export default VoucherTerms;
